import React from 'react';
import FooterColumnHead from './FooterColumnHead';
import FooterColumnContent from './FooterColumnContent';

interface Props {
  column: {
    uid: any,
    rows: {
      values: any,
    },
    head: {
      title: string,
    },
  };
}

const FooterColumn: React.FC<Props> = (props: Props) => {
  return (
    <div className="col col-12 col-xl-3 float-md-start">
      <FooterColumnHead
        title={props.column.head.title}
        uid={props.column.uid}
      />
      <FooterColumnContent rows={props.column.rows.values} />
    </div>
  );
};

export default FooterColumn;
